import { PaginaCrud } from '../components/PaginaCrud'
import type { Perfil } from '../types'

export default function Perfiles() {
  return (
    <PaginaCrud<Perfil>
      titulo="Perfiles"
      recurso="perfiles"
      llave="id"
      columnas={[
        { campo: 'nombre', titulo: 'Nombre' },
        { campo: 'descripcion', titulo: 'Descripcion', render: (p) => p.descripcion || '-' },
        { campo: 'activo', titulo: 'Activo', render: (p) => (p.activo ? 'Si' : 'No') },
      ]}
      campos={[
        { nombre: 'nombre', etiqueta: 'Nombre', tipo: 'texto', requerido: true },
        { nombre: 'descripcion', etiqueta: 'Descripcion', tipo: 'texto' },
        { nombre: 'activo', etiqueta: 'Activo', tipo: 'checkbox' },
      ]}
      valorInicial={{ tenantId: 1, activo: true }}
    />
  )
}
